/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');

var PlaceholderView = require('common/views/PlaceholderView');

var ConSerComplaintSectionRelatedComplaintsView = require('../views/ConSerComplaintSectionRelatedComplaintsView');

var GetRelatedComplaint = require('../services/GetRelatedComplaint');

module.exports = {
  channel: 'cs',

  event: 'build:related-complaints-section-view',

  builder: function(complaintId) {
    return new PlaceholderView({
      viewPromise: buildRelatedComplaintSection(complaintId)
    });
  }
};

function buildRelatedComplaintSection(complaintId) {
  var deferred = $.Deferred();
  GetRelatedComplaint(complaintId)
    .done(function(relatedComplaints) {
      var relatedComplaintsSection = new ConSerComplaintSectionRelatedComplaintsView({
        model: new Backbone.Model({ complaintId: complaintId, relatedComplaints: relatedComplaints })
      });
      deferred.resolve(relatedComplaintsSection);
    })
    .fail(function(err) {
      deferred.reject(err);
    });
  return deferred.promise();
}
